import { Target, Construction } from 'lucide-react'

export default function ComercialMetasPage() {
  return (
    <div className="p-6 space-y-4">
      <div>
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <Target size={22} className="text-violet-600" /> Metas Comerciais
        </h1>
        <p className="text-xs text-ink-500">Defina metas de vendas, margem e canais — acompanhamento em tempo real</p>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 text-center">
        <Construction size={32} className="text-amber-600 mx-auto mb-3" />
        <h3 className="text-lg font-semibold text-amber-900 mb-2">Em desenvolvimento</h3>
        <p className="text-sm text-amber-800 max-w-md mx-auto">
          Aqui você vai poder cadastrar metas mensais por canal (ML, Tray, balcão), por categoria de produto, e acompanhar % atingida em tempo real com base nos lançamentos do DRE.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div className="border border-ink-200 rounded p-4">
          <div className="text-xs text-ink-500 uppercase font-semibold">Meta de Receita</div>
          <div className="text-lg font-bold mt-1">— em breve —</div>
        </div>
        <div className="border border-ink-200 rounded p-4">
          <div className="text-xs text-ink-500 uppercase font-semibold">Meta de Margem</div>
          <div className="text-lg font-bold mt-1">— em breve —</div>
        </div>
        <div className="border border-ink-200 rounded p-4">
          <div className="text-xs text-ink-500 uppercase font-semibold">Meta de Conversão</div>
          <div className="text-lg font-bold mt-1">— em breve —</div>
        </div>
      </div>
    </div>
  )
}
